import React from 'react';
import classNames from 'classnames';
import Slider from 'react-slick';
import { NamedLink, SportsListingCard } from '../../../components';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';

import { sportsOptions, sportsOrder } from '../../../config/configExtras';

function ExploreSports(props) {
  const { sliderSettings, useHistoryPush, isMobileLayout, intl } = props;

  // Filter sportsOptions to include only featured items
  const featuredSportsOptions = sportsOptions.filter(option => option.isFeatured);

  // Sort the featured sportsOptions based on predefined order
  const sortedSportsOptions = featuredSportsOptions.sort((a, b) => {
    return sportsOrder.indexOf(a.key) - sportsOrder.indexOf(b.key);
  });

  return (
    <div className={classNames(css.popularSessions, css.blackBgWrapper, css.sectionPadding)}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>{intl.formatMessage({ id: 'ExploreSports.title' })}</h2>
            <p>
              {intl.formatMessage({
                id: 'ExploreSports.description',
              })}
            </p>
          </div>
          <div className={css.rightSec}>
            <NamedLink className={css.viewbtn} name="SportsPage">
              {intl.formatMessage({ id: 'ExploreSports.viewAll' })}
            </NamedLink>
          </div>
        </div>
        <div className={css.sectionContent}>
          <div className={css.featuredListingsContent}>
            <div className={css.templatesSlider}>
              <Slider
                className={css.exploreSportSlider}
                {...{ ...sliderSettings, arrows: !isMobileLayout }}
              >
                {sortedSportsOptions.map((step, index) => (
                  <SportsListingCard key={index} step={step} onRedirect={useHistoryPush} />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 4.5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3.5,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2.5,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.3,
      },
    },
  ],
};

// Assign default props
ExploreSports.defaultProps = {
  sliderSettings,
};

export default ExploreSports;
